export default __webpack_public_path__ + "static/media/fire-protection.c63a7048.png";